export const paymentStatuses = {
  created: "ایجادشده", initialized: "در انتظار پرداخت", reserved: "رزروشده", uncleared: "در انتظار تأیید",
  completed: "پرداخت تأییدشده", void: "باطل‌شده", cancelled: "لغوشده", declined: "ردشده", expired: "منقضی‌شده",
  refunded: "بازپرداخت کامل", partial_refunded: "بازپرداخت جزئی", chargeback: "برگشت وجه", shipped: "ارسال‌شده",
};
export function paymentStatusLabel(payment) {
  return payment.pendingRefundId ? "بازپرداخت در انتظار تأیید" : (paymentStatuses[payment.status] || payment.status);
}
export function paymentAmount(amount, currency) {
  try {
    const formatter = new Intl.NumberFormat("fa-IR", { style: "currency", currency });
    const digits = formatter.resolvedOptions().maximumFractionDigits;
    return formatter.format(amount / (10 ** digits));
  } catch { return `${amount} ${currency} (واحد خرد)`; }
}
export function paymentDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString("fa-IR");
}
